import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "exchange-arrows_1defd",
  "use": "exchange-arrows_1defd-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol viewBox=\"0 0 1024 1024\" id=\"exchange-arrows_1defd\">\n    <path d=\"M227.556 284.444h398.222v113.778H227.556v170.667L0 341.333l227.556-227.556v170.667zM1024 682.667L796.444 910.223V739.556H398.222V625.778h398.222V455.111L1024 682.667z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol